import type {Add, ClearByKey} from './types';

const add: Add = () => Promise.resolve();

const clearByKey: ClearByKey = () => {};

export {add, clearByKey};
